import { createOutlineIcon } from "../createIcon";

export const CalendarDateOutlineIcon = createOutlineIcon(
  <>
    <path d="M7.33 7.614h10.12M6.875 2v1.832m0 0h10.624m-10.624 0c-1.76 0-3.188 1.451-3.188 3.242v10.809c.001 1.79 1.428 3.242 3.188 3.242H17.5c1.76 0 3.188-1.452 3.187-3.243V7.074c0-1.79-1.427-3.242-3.188-3.242M17.5 2v1.832m-7.436 13.51v-6.485l-2.125 1.621m7.968 4.864v-6.485l-2.125 1.621" />
  </>,
  "CalendarDateOutlineIcon"
);
